import { useEffect } from 'react';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { setPlpCurrent } from '@app/store/plp/actions';
import ProductListPage from '../plp';

const Category = () => {
  const { category } = useParams();
  const { search } = useLocation();
  const { categoryId } = queryString.parse(search);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPlpCurrent(categoryId ?? category));
  }, [dispatch, category, categoryId]);

  return <ProductListPage />;
};

export default Category;
